import { NgModule } from '@angular/core';
import { ComponentModule } from '@root/component/component.module';
import { SharedModule } from '@root/shared/shared.module';
import { ModuleSharedComponentModule } from '../component/module-shared-component.module';
import { HostexDemoComponent } from './demo/demo.component';

const Modules = [SharedModule, ComponentModule, ModuleSharedComponentModule];

const Components = [HostexDemoComponent];

@NgModule({
  imports: [...Modules],
  declarations: [...Components],
  exports: [...Components, ...Modules],
})
export class CalendarSharedComponentsModule {
  constructor() {}
}
